import React from 'react';

const Footer = () => {
  const today = new Date();
  const year = today.getFullYear();
    return (
        <footer id="footer">
      {/* <!-- Footer widgets --> */}
      <section id="footer-widgets" className="section footer-widgets">
        <div className="container">
          <div className="row gx-4 gy-5">
            <div className="col-lg-6">
              <div className="row gx-4 gy-5">
                <div className="col-sm-6" data-aos="fade-up">
                  <h2 className="heading__1">Youbie</h2>
                  <p className="para">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                    sed do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua.
                  </p>
                </div>
                <div className="col-sm-6 d-none d-md-block">
                  <div className="widget" data-aos="fade-up">
                    <h4 className="widget__title">LEGAL & SAFETY</h4>
                    <ul className="footer-nav">
                      <li className="footer-nav__item">
                        <a href="#" className="footer-nav__item-link">
                          Terms & Conditions
                        </a>
                      </li>
                      <li className="footer-nav__item">
                        <a href="#" className="footer-nav__item-link">
                          Privacy Policy
                        </a>
                      </li>
                      <li className="footer-nav__item">
                        <a href="#" className="footer-nav__item-link">
                          Cookies Policy
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="row gx-4 gy-5">
                <div className="col-sm-6 col-md-4 d-md-none">
                  <div className="widget" data-aos="fade-up">
                    <h4 className="widget__title">LEGAL & SAFETY</h4>
                    <ul className="footer-nav">
                      <li className="footer-nav__item">
                        <a href="#" className="footer-nav__item-link">
                          Terms & Conditions
                        </a>
                      </li>
                      <li className="footer-nav__item">
                        <a href="#" className="footer-nav__item-link">
                          Privacy Policy
                        </a>
                      </li>
                      <li className="footer-nav__item">
                        <a href="#" className="footer-nav__item-link">
                          Cookies Policy
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-sm-6 col-md-4">
                  <div className="widget" data-aos="fade-up">
                    <h4 className="widget__title">Links</h4>
                    <ul className="footer-nav">
                      <li className="footer-nav__item">
                        <a href="#" className="footer-nav__item-link">
                          Website.com
                        </a>
                      </li>
                      <li className="footer-nav__item">
                        <a href="#" className="footer-nav__item-link">
                          Site.com
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-sm-6 col-md-4">
                  <div className="widget" data-aos="fade-up">
                    <h4 className="widget__title">Socials</h4>
                    <ul className="footer-nav">
                      <li className="footer-nav__item">
                        <a href="#" className="footer-nav__item-link">
                          Twitter
                        </a>
                      </li>
                      <li className="footer-nav__item">
                        <a href="#" className="footer-nav__item-link">
                          Facebook
                        </a>
                      </li>
                      <li className="footer-nav__item">
                        <a href="#" className="footer-nav__item-link">
                          Instagram
                        </a>
                      </li>
                      <li className="footer-nav__item">
                        <a href="#" className="footer-nav__item-link">
                          Youtube
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-sm-6 col-md-4">
                  <div className="widget" data-aos="fade-up">
                    <h4 className="widget__title">Company</h4>
                    <ul className="footer-nav">
                      <li className="footer-nav__item">
                        <a href="#" className="footer-nav__item-link"> About </a>
                      </li>
                      <li className="footer-nav__item">
                        <a href="#" className="footer-nav__item-link">
                          Contact
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- Footer widgets --> */}

      {/* <!-- Copyright --> */}
      <section id="copyright" className="copyright">
        <div className="container">
          <p className="text">COPYRIGHT <span style={{color:"#01eaff"}}>©{year}</span> CREATED BY YOUBIE</p>
        </div>
      </section>
      {/* <!-- Copyright --> */}
    </footer>
    );
};

export default Footer;